const CompanyProperty = ({
    listingId = '',
    name = '',
    street = '',
    state = '',
    city = '',
    listingIds = [],
    contactEmail = '',
    active = false,
    unit = '',
} = {}) => ({
    listingId: String(listingId),
    name: String(name),
    street: String(street),
    state: String(state),
    city: String(city),
    listingIds,
    contactEmail: String(contactEmail),
    active: Boolean(active),
    unit: String(unit),
});

export default CompanyProperty;
